module.exports = __webpack_public_path__ + "static/media/finance.e0a49017.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/finance.png
// module id = 507
// module chunks = 0